import getActionsByDocument from '../../../../components/logs/actions';

const DOCUMENT = 'TALENT_LOGS_';

export default getActionsByDocument(DOCUMENT);
